import React from 'react';
import clsx from 'clsx';

import './index.scss';

import BasicCheckBoxInput from 'components/atoms/Input/BasicCheckBoxInput';
import RadioInput from 'components/atoms/Input/RadioInput';

import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';

const PcAccordionCheckBox = ({
  // radio
  value,
  label,
  onChange,
  checked,
  id,

  // checkList
  title,
  list = [],
  require,
}) => {

  const CheckList = ({ list: detail }) => {
    return (
      <div className="">
        {detail.map(data => (
          <span className="checkList" key={data.label}>
            <BasicCheckBoxInput value={data.value} onChange={data.checkBoxOnChange} checked={data.checked} label={data.label} id={data.id} />
          </span>
        ),
        )}
      </div>
    );
  };

  return (
    <div className="PcAccordionCheckBox">
      <div className="accordionAreaWrapper">
        <RadioInput id={id} value={value} onChange={onChange} checked={checked} label={label} />
        <div className={clsx('pcCollpseArea', { checked })}>
          <div className="arrowArea">
            <div className="pc-background-cmnt" />
          </div>
          <div className="pcCollpseAreaBackground">
            {title}
            <RequiredOrOptionalIcon label={require} />
                    
            <CheckList list={list} />
          </div>
        </div>
      </div>
    </div>

  );
};

export default PcAccordionCheckBox;